/**
 * @generated SignedSource<<ca7ffcdd64fd4565baad11cc6d5bf8b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteRewardInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
  rewardId: string;
};
export type rewardEditor_DeleteRewardMutation$variables = {
  input: DeleteRewardInput;
};
export type rewardEditor_DeleteRewardMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly deleteReward: {
        readonly contentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"rewardEditor_TreeNodeFragment">;
        };
      } | null;
    };
  };
};
export type rewardEditor_DeleteRewardMutation = {
  response: rewardEditor_DeleteRewardMutation$data;
  variables: rewardEditor_DeleteRewardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rewardEditor_DeleteRewardMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "DeleteRewardPayload",
                "kind": "LinkedField",
                "name": "deleteReward",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "rewardEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rewardEditor_DeleteRewardMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "DeleteRewardPayload",
                "kind": "LinkedField",
                "name": "deleteReward",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rewards",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isReward"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ExternalLicenseRewardData",
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ExternalLicensePool",
                                            "kind": "LinkedField",
                                            "name": "pool",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ExternalLicensePoolData",
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "name",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "superId",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ExternalLicenseReward",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bundleIds",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "IHKCertificateBundle",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rewards",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1141ea1b20465033dc9d31ab872cd25f",
    "id": null,
    "metadata": {},
    "name": "rewardEditor_DeleteRewardMutation",
    "operationKind": "mutation",
    "text": "mutation rewardEditor_DeleteRewardMutation(\n  $input: DeleteRewardInput!\n) {\n  Admin {\n    Tree {\n      deleteReward(input: $input) {\n        contentNode {\n          ...rewardEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment createExternalLicenseRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment createIhkCertificateRewardBundleButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment createIhkCertificateRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment externalLicenseRewardForm_ExternalLicenseRewardFragment on ExternalLicenseReward {\n  ... on Reward {\n    __isReward: __typename\n    id\n  }\n  superId\n  data {\n    pool {\n      id\n      data {\n        name\n      }\n    }\n  }\n}\n\nfragment ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment on IHKCertificateBundle {\n  id\n  bundleIds\n}\n\nfragment rewardEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        id\n        kind\n        ... on ExternalLicenseReward {\n          data {\n            pool {\n              data {\n                name\n              }\n              id\n            }\n          }\n        }\n        ...rewardForm_RewardFragment\n      }\n    }\n  }\n  ...rewardForm_TreeNodeFragment\n  ...createExternalLicenseRewardButton_TreeNodeFragment\n  ...createIhkCertificateRewardButton_TreeNodeFragment\n  ...createIhkCertificateRewardBundleButton_TreeNodeFragment\n}\n\nfragment rewardForm_RewardFragment on Reward {\n  __isReward: __typename\n  id\n  kind\n  ... on ExternalLicenseReward {\n    ...externalLicenseRewardForm_ExternalLicenseRewardFragment\n  }\n  ... on IHKCertificateBundle {\n    ...ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment\n  }\n}\n\nfragment rewardForm_TreeNodeFragment on TreeNode {\n  id\n}\n"
  }
};
})();

(node as any).hash = "990962e0e1a1334ff4c92e4377cbbda5";

export default node;
